import { Menu } from '@shinetools/lumen-react'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { suppliersTableColumnHeaderLocaleKeys } from '../../../../constants/suppliersTableColumnHeaderLocaleKeys'
import { SuppliersTableColumn } from '../../../../types/suppliersTableColumn'
import { SuppliersTableHideableColumnKey } from '../../../../types/suppliersTableHideableColumnKey'
import { isSuppliersTableHideableColumnKey } from '../../../../utils/isSuppliersTableHideableColumnKey'
import { SuppliersTableColumnSelectionMenuTrigger } from './elements'

interface SuppliersTableColumnSelectionMenuProps {
  columns: SuppliersTableColumn[]
  hiddenColumnKeys: Set<SuppliersTableHideableColumnKey>
  setHiddenColumnKeys: (hiddenColumnKeys: Set<SuppliersTableHideableColumnKey>) => void
}

export const SuppliersTableColumnSelectionMenu = ({
  columns,
  hiddenColumnKeys,
  setHiddenColumnKeys,
}: SuppliersTableColumnSelectionMenuProps): ReactElement => {
  const { t } = useTranslation()
  const hideableColumns = useMemo<SuppliersTableColumn[]>(() => columns.filter((column) => column.hideable), [columns])

  return (
    <Menu
      aria-label={t('table_column_toggler.toggle_columns')}
      trigger={<SuppliersTableColumnSelectionMenuTrigger />}
      width="hug"
    >
      <Menu.Group>
        {hideableColumns
          .map(({ key }) => {
            if (!isSuppliersTableHideableColumnKey(key)) {
              return null
            }

            return (
              <Menu.Checkbox
                key={key}
                label={t(suppliersTableColumnHeaderLocaleKeys[key])}
                checked={!hiddenColumnKeys.has(key)}
                onCheckedChange={(checked) => {
                  const newHiddenColumnKeys = new Set(hiddenColumnKeys)
                  if (checked) {
                    newHiddenColumnKeys.delete(key)
                  } else {
                    newHiddenColumnKeys.add(key)
                  }
                  setHiddenColumnKeys(newHiddenColumnKeys)
                }}
              />
            )
          })
          .filter(Boolean)}
      </Menu.Group>
    </Menu>
  )
}
